import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { authFetch } from "../../lib/api"

export default function SavedHomes() {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const load = () => {
    setError("")
    authFetch("/api/saved-homes")
      .then((r) => r.json())
      .then((data) => {
        if (data.error) setError(data.error)
        else setList(data.savedHomes || [])
      })
      .catch(() => setError("Failed to load saved homes"))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    load()
  }, [])

  const handleRemove = async (listingId) => {
    if (!window.confirm("Remove from saved homes?")) return
    const res = await authFetch(`/api/saved-homes/${listingId}`, { method: "DELETE" })
    if (res.ok) setList((prev) => prev.filter((item) => item.listingId !== listingId))
  }

  return (
    <section className='dashboard-card'>
      <div className='dashboard-card__header'>
        <div>
          <span className='dashboard-eyebrow'>My list</span>
          <h2>Saved homes</h2>
          <p>Listings you have saved for review, comparison, or follow-up.</p>
        </div>
        <Link to='/listings' className='dashboard-primary-action'>
          <i className='fa-solid fa-plus'></i>
          Add homes
        </Link>
      </div>

      {error && <p className='dashboard-error'>{error}</p>}
      {loading ? (
        <p>Loading...</p>
      ) : list.length === 0 ? (
        <div className='dashboard-empty'>
          No saved homes yet. Save listings from the Listings page to build your shortlist.
        </div>
      ) : (
        <div className='dashboard-grid'>
          {list.map((item) => (
            <article key={item.id} className='dashboard-property-card'>
              {item.listing && (
                <>
                  {item.listing.cover && (
                    <img src={item.listing.cover} alt={item.listing.name || "Saved property"} />
                  )}
                  <div className='dashboard-property-card__body'>
                    <h3>{item.listing.name}</h3>
                    <p>{item.listing.location}</p>
                    <strong>{item.listing.price}</strong>
                    <div className='dashboard-list__actions'>
                      <Link to={`/listings/${item.listingId}`} className='btn btn--secondary'>
                        View
                      </Link>
                      <button
                        type='button'
                        className='btn btn--danger'
                        onClick={() => handleRemove(item.listingId)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </>
              )}
            </article>
          ))}
        </div>
      )}
    </section>
  )
}
